import React from 'react';
import hand_holder from '../../../assets/images/physical_theropy/hand_holder.jpg';
import baby_with_toy from '../../../assets/images/physical_theropy/baby_with_toy.jpg';
import { motion } from 'framer-motion';

const Benefits = () => {
  const TitleAndDescription = ({ title, description }) => {
    return (
      <div className="flex flex-col gap-1">
        <h2 className="text-[26px] sm:text-[28px] text-[#7E4B9D] font-bold">
          {title}
        </h2>
        <p
          className="text-lg text-secondary max-w-auto lg:max-w-[400px]"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    );
  };

  return (
    <main className="relative max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20 pb-0 z-10">
      <div className="mb-8">
        <h2 className="text-[34px] sm:text-[40px] md:text-[45px] text-[#7E4B9D] font-bold leading-[50px]">
          Benefits of Pediatric Physical Therapy
        </h2>
      </div>
      <div className="flex flex-col gap-10">
        <div className="flex flex-col lg:flex-row gap-10 md:gap-20">
          <div className="flex-1 flex flex-col gap-4 sm:gap-10">
            <TitleAndDescription
              title="Improved Motor Skills"
              description="Through targeted interventions, physical therapy helps children develop and enhance their gross motor skills, balance, endurance, agility, mobility, and coordination."
            />
            <TitleAndDescription
              title="Increased Independence"
              description="By improving physical abilities, children can explore the world around them, interact with peers and caregivers, and gain independence in activities of daily living, such as dressing, eating, and self-care tasks."
            />
            <TitleAndDescription
              title="Pain Management"
              description="Physical therapy can assist in managing pain associated with certain conditions or injuries, promoting comfort and improved quality of life."
            />
          </div>
          <div className="flex-1 flex flex-col gap-4 sm:gap-10 items-center justify-end">
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 1, ease: 'easeOut' }}
              viewport={{ once: true, amount: 0.5 }}
            >
              <img
                src={hand_holder}
                alt="Physical therapy for child with obstacle course in Wasilla"
                className=" max-w-auto sm:max-w-[600px]"
              />
            </motion.div>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-10 mt-28">
        <div className="flex flex-col-reverse lg:flex-row gap-10 md:gap-20">
          <div className="flex-1 flex flex-col gap-4 sm:gap-10">
            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{
                opacity: 1,
                y: [100, -30, 15, -10, 0],
              }}
              transition={{
                duration: 1.2,
                ease: 'easeOut',
              }}
              viewport={{ once: true, amount: 0.5 }}
            >
              <img
                src={baby_with_toy}
                alt="Toddler using sensory toys in Wasilla occupational therapy"
                className="w-[87%]"
              />
            </motion.div>
          </div>
          <div className="flex-1 flex flex-col gap-4 sm:gap-10">
            <TitleAndDescription
              title="Enhanced Mobility"
              description={`Children who have difficulty with mobility can benefit from physical therapy to improve movement, strength, postural stability, walking mechanics, and navigation of their environment `}
            />
            <TitleAndDescription
              title="Supportive Devices"
              description="Physical therapists can recommend and guide the use of assistive devices, orthotics, or adaptive equipment to facilitate improved movement and function"
            />
            <TitleAndDescription
              title="Developmental Support"
              description="Our physical therapists are doctors in their field, which means they have the expertise to support your child, provide therapy diagnoses based on their assessment of your child, develop an individualized care plan to address impairments and work towards improved function, and help them grow through each step of their developmental journey."
            />
          </div>
        </div>
      </div>
    </main>
  );
};

export default Benefits;
